module.exports = __webpack_public_path__ + "img/close.c7ba5117.svg";